import { route } from "./lib/routing";

export const setup = route("/setup/");
export const chat = route("/chat/:network/:buffer/");
